import {
  Box,
  Container,
  Text,
  useColorModeValue,
} from '@chakra-ui/react';


export default function Footer() {
  const borderColor = useColorModeValue('gray.200', 'gray.700');
  const textColor = useColorModeValue('gray.600', 'gray.400');
  const year = new Date().getFullYear();

  return (
    <Box
      as="footer"
      py={10}
      borderTop="1px solid"
      borderColor={borderColor}
    >
      <Container maxW="7xl" centerContent>
        <Text
          fontSize="sm"
          color={textColor}
          textAlign="center"
        >
          © {year} Danish Ismail. All rights reserved.
        </Text>
      </Container>
    </Box>
  );
}
